import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => setMenuOpen(false), [location]);

  return (
    <nav className={`nav${scrolled ? " nav--scrolled" : ""}`}>
      <div className="nav__inner">
        {/* Wordmark */}
        <NavLink to="/" className="nav__wordmark">
          <span className="nav__wordmark-display">Airi (Iris) Ryu</span>
          <span className="nav__wordmark-dot">.</span>
        </NavLink>

        {/* Desktop links */}
        <ul className="nav__links">
          {[
            { label: "Home", to: "/" },
            { label: "Portfolio", to: "/portfolio" },
            { label: "Contact", to: "/contact" },
          ].map(({ label, to }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={to === "/"}
                className={({ isActive }) =>
                  `nav__link${isActive ? " nav__link--active" : ""}`
                }
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Mobile hamburger */}
        <button
          className={`nav__burger${menuOpen ? " nav__burger--open" : ""}`}
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile drawer */}
      <div className={`nav__drawer${menuOpen ? " nav__drawer--open" : ""}`}>
        {[
          { label: "Home", to: "/" },
          { label: "Portfolio", to: "/portfolio" },
          { label: "Contact", to: "/contact" },
        ].map(({ label, to }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            className="nav__drawer-link"
          >
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
